export default __webpack_public_path__ + "static/media/package.6df72c0e.png";